import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals';

type ReportHandler = (metric: Metric) => void;

const vitalsUrl = 'https://vitals.vercel-analytics.com/v1/vitals';

function getConnectionSpeed(): string {
  const nav = navigator as Navigator & {
    connection?: { effectiveType?: string };
  };
  return nav.connection?.effectiveType ?? '';
}

function sendToAnalytics(metric: Metric, options: { analyticsId?: string; debug?: boolean }) {
  const { analyticsId, debug } = options;

  if (debug) {
    console.log('[Web Vitals]', metric.name, metric.value.toFixed(2), metric.rating);
  }

  // Send to Vercel Analytics if configured
  if (analyticsId) {
    const body = {
      dsn: analyticsId,
      id: metric.id,
      page: window.location.pathname,
      href: window.location.href,
      event_name: metric.name,
      value: metric.value.toString(),
      speed: getConnectionSpeed(),
    };

    const blob = new Blob([new URLSearchParams(body).toString()], {
      type: 'application/x-www-form-urlencoded',
    });

    if (navigator.sendBeacon) {
      navigator.sendBeacon(vitalsUrl, blob);
    } else {
      fetch(vitalsUrl, {
        body: blob,
        method: 'POST',
        credentials: 'omit',
        keepalive: true,
      });
    }
  }

  // Send to PostHog if available (uses types from posthog-js)
  const posthog = (window as { posthog?: { capture: (event: string, properties?: Record<string, unknown>) => void } }).posthog;
  if (posthog) {
    posthog.capture('web_vitals', {
      metric_name: metric.name,
      metric_value: metric.value,
      metric_rating: metric.rating,
      metric_id: metric.id,
      page: window.location.pathname,
    });
  }
}

export function reportWebVitals(options: { analyticsId?: string; debug?: boolean } = {}) {
  const handler: ReportHandler = (metric) => sendToAnalytics(metric, options);

  // Core Web Vitals
  onCLS(handler);
  onINP(handler);
  onLCP(handler);

  // Other metrics
  onFCP(handler);
  onTTFB(handler);
}
